import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";
import { Subject } from "rxjs";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { DataElement } from "src/app/shared/models/common";
import { Order, OrderEmail } from "src/app/shared/models/order.model";
import {
  currentOrder,
  orderEmailTemplates,
} from "src/app/shared/ngrx/ngrx-selectors";
import { DataService } from "src/app/shared/services/data.service";
import { AutoCompleteModule } from "primeng/autocomplete";
import { Textarea } from "primeng/textarea";
import { BroshService } from "src/app/shared/services/brosh.service";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "edit-order-email",
  standalone: true,
  imports: [
    TranslateModule,
    InputWrapComponent,
    CommonModule,
    FormsModule,
    SelectModule,
    SpinnerComponent,
    AutoCompleteModule,
    Textarea,
  ],
  templateUrl: "./edit-order-email.component.html",
  styleUrl: "./edit-order-email.component.scss",
})
export class EditOrderEmailComponent {
  @Input() email: OrderEmail;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter();

  saving: boolean;
  destroy$ = new Subject();
  selectedTemplate?: DataElement;

  get templates(): DataElement[] {
    return this.store.selectSignal(orderEmailTemplates)();
  }

  get editable(): boolean {
    return this.email.status == "NEW";
  }

  get currentOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  constructor(
    private readonly store: Store,
    private dataService: DataService,
    private broshService: BroshService,
    private cd: ChangeDetectorRef,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    if (this.templates.loading) {
      this.geTemplatesList();
    } else {
      this.setTemplate();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  geTemplatesList() {
    this.dataService.getOrderEmailTemplateList().subscribe(() => {
      this.setTemplate();
    });
  }

  setTemplate() {
    if (this.email.templateCode) {
      this.selectedTemplate = this.templates.find(
        (t) => t.id == this.email.templateCode
      );
    }
  }

  public closePanel() {
    this.onCancel.emit();
  }

  onTemplateSelected() {
    this.broshService
      .generateOrderEmailTemplate(
        this.currentOrder.orderId,
        this.selectedTemplate?.id
      )
      .subscribe((data) => {
        this.email.body = data.body;
        this.email.subject = data.subject;
        this.email.recipients = data.recipients;
        this.cd.detectChanges();
      });
  }

  cancelAlert() {
    this.save("CANCELLED");
  }

  saveEnabled(): boolean {
    return (
      this.email.status == "NEW" &&
      this.email.body &&
      this.email.subject &&
      this.selectedTemplate != null
    );
  }

  sendEnabled(): boolean {
    return this.saveEnabled && this.email.recipients.length > 0;
  }

  save(updStatus: string) {
    this.saving = true;
    this.broshService
      .updateOrderEmail(
        this.currentOrder.orderId,
        this.email,
        updStatus,
        this.selectedTemplate?.id,
        this.authService.currentUser.userDescr
      )
      .subscribe(
        () => {
          this.saving = false;
          this.onSave.emit();
        },
        (err) => {
          this.saving = false;
        }
      );
  }
}
